import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import {
  createTicketUpdate,
  updateTicketUpdate,
  deleteTicketUpdate,
  retryTicketUpdateEmail,
  translateContent,
} from "../services/ticketUpdateApi";

export function useCreateTicketUpdate(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createTicketUpdate,
    onSuccess: (data) => {
      queryClient.setQueryData(queryData, (old) => (old ? [...old, data] : data));
      queryClient.invalidateQueries(["attachments", { entity_type: "ticket_update", entity_id: data.id }]);
      queryClient.invalidateQueries(["files", { entity_type: "ticket_update", entity_id: data.id }]);
    },
    onError: (error) => {
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useUpdateTicketUpdate(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateTicketUpdate,
    onSuccess: (data) => {
      queryClient.setQueryData(queryData, (old) => old?.map((item) => (item.id === data.id ? data : item)));
      queryClient.invalidateQueries(["files", { entity_type: "ticket_update", entity_id: data.id }]);
      handleSuccess?.(data);
    },
    onError: (error) => {
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useDeleteTicketUpdate(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteTicketUpdate,
    onSuccess: (data) => {
      queryClient.invalidateQueries(queryData);
      handleSuccess?.(data);
    },
    onError: (error) => {
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useRetryTicketUpdateEmail(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: retryTicketUpdateEmail,
    onSuccess: (data) => {
      queryClient.setQueryData(queryData, (old) => old?.map((item) => (item.id === data.id ? data : item)));
      handleSuccess?.(data);
    },
    onError: (error) => {
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useTicketUpdateTranslate() {
  const { t } = useTranslation();

  return useMutation({
    mutationFn: ({ content, sourceLanguage, targetLanguage }) =>
      translateContent(content, sourceLanguage, targetLanguage),
    onError: (error) => {
      const errorMessage = error.message || t("items.messages.translateError", { defaultValue: "Translation failed" });
      toast.error(errorMessage);
    },
  });
}
